"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Details = void 0;
const get_value_1 = __importDefault(require("get-value"));
const react_1 = __importDefault(require("react"));
const DetailField_1 = require("./DetailField");
exports.Details = ({ object, properties }) => (react_1.default.createElement("table", { className: "Details" },
    react_1.default.createElement("tbody", null, properties.map((prop) => (react_1.default.createElement(DetailField_1.DetailField, { key: prop.dataField, label: prop.text }, prop.formatter
        ? prop.formatter(get_value_1.default(object, prop.dataField), object)
        : get_value_1.default(object, prop.dataField)))))));
//# sourceMappingURL=Details.js.map